var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"commonImageCard",style:({ width: _vm.width, height: _vm.height })},[_c('img',{staticClass:"commonImage",attrs:{"src":_vm.src},on:{"click":_vm.showImage}})])
}
var staticRenderFns = []

export { render, staticRenderFns }